var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-cell-group',{staticClass:"publish-form-card",class:{ 'publish-form-card--expanded': _vm.expanded },attrs:{"border":false}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }